<template>
  <div class="ads-list-page">
    <div class="global-header-wrap">
      <div class="left-part">
        <span>广告管理</span>
      </div>
      <div class="right-part">
        <button
          class="global-button-style"
          @click="$router.push({ name: 'createAds' })"
        >
          <img src="@/assets/img/cmb_btn_add.png" />{{ $t("commonMsg.new") }}
        </button>
      </div>
    </div>
    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <div class="list-container" v-bar>
        <div class="aa">
          <div v-for="(item, idx) in ads" :key="idx" class="ads-item">
            <el-carousel
              height="150px"
              trigger="click"
              indicator-position="outside"
              :autoplay="false"
              class="ads-cover"
            >
              <el-carousel-item
                v-for="(subItem, num) in item.pic_address"
                :key="num"
              >
                <img class="ads-img" :src="subItem.addr" />
              </el-carousel-item>
            </el-carousel>
            <div class="ads-info">
              <p v-if="item.relate_type === 1">广告类型：图书广告</p>
              <p v-if="item.relate_type === 2">广告类型：外部连接</p>
              <p v-if="item.relate_type === 4">广告类型：图书详情页</p>
              <p v-if="item.relate_type === 5">广告类型：纯展示</p>
              <p v-if="item.relate_type === 6">广告类型：跳到书单</p>
              <p v-if="item.relate_type === 7">广告类型：跳到VIP页面</p>

              <p v-if="item.relate_value === '10000'">广告的值：默认书单</p>
              <p v-if="item.relate_value === '10001'">广告的值：推荐书单</p>
              <p v-if="item.relate_value === '10002'">广告的值：VIP频道</p>
              <p v-if="item.relate_value === '10003'">广告的值：新书频道</p>
              <p v-if="item.relate_value === '10004'">广告的值：特价频道</p>
              <p v-if="item.relate_value === '10005'">广告的值：排行榜</p>

              <p
                v-if="
                  item.relate_value === 10001 &&
                    item.relate_value === 10002 &&
                    item.relate_value === 10003 &&
                    item.relate_value === 10004 &&
                    item.relate_value === 10005
                "
              >
                {{ item.relate_value }}
              </p>

              <p v-if="item.relate_value === ''">广告的值：暂无</p>

              <p v-if="item.state === 0">
                发布状态：<span class="grey">未发布</span>
              </p>
              <p v-if="item.state === 1">
                发布状态：<span class="grey">测试</span>
              </p>
              <p v-if="item.state === 2">
                发布状态：<span class="green">已发布</span>
              </p>
              <p v-if="item.state === 3">
                发布状态：<span class="grey">已废弃</span>
              </p>
              <p class="date">更新日期： {{ item.updated_at | filterDate }}</p>
            </div>
            <div class="ads-btn">
              <i
                class="el-icon-edit ads-el-icon"
                title="编辑"
                @click="editAd(item)"
              ></i>
              <i
                class="el-icon-upload ads-el-icon on-publish"
                title="发布"
                v-if="item.state === 0 || item.state === 1"
                @click="publish(item, '2')"
              ></i>
              <i
                class="el-icon-upload ads-el-icon off-publish"
                title="取消发布"
                v-if="item.state === 2"
                @click="publish(item, '0')"
              ></i>
              <i
                class="el-icon-upload ads-el-icon disable-publish"
                v-if="item.state === 3"
              ></i>
              <i
                class="el-icon-delete ads-el-icon ads-del"
                title="删除"
                @click="remove(item)"
              ></i>
            </div>
          </div>
        </div>
      </div>
    </el-card>
    <transition name="fade">
      <DelPopup @deleteHandle="deleteHandle" v-if="delPopup" />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DelPopup from "@/components/delPopup";
export default {
  components: {
    DelPopup
  },
  computed: {
    ...mapGetters(["delPopup"])
  },
  data() {
    return {
      ads: [],
      adsItem: null
    };
  },
  methods: {
    getAds() {
      let params = { orderBy: "updated_at" };
      this.$http.getAds(params).then(res => {
        this.ads = res.data.rows;
      });
    },

    publish(item, type) {
      this.$http.publicAds(item.id, { state: type }).then(res => {
        switch (type) {
          case "0":
            this.elMsg("已取消发布", "success");
            break;
          case "2":
            this.elMsg(this.$t("alertMsg.releaseSuccess"), "success");
            break;

          default:
            break;
        }
        this.getAds();
      });
    },

    editAd(item) {
      this.adsItem = item;
      this.$router.push({ name: "createAds", query: { id: item.id } });
    },

    remove(item) {
      this.adsItem = item;
      this.$store.commit("windowHandle", "delPopup");
    },
    deleteHandle() {
      this.$http.delAds(this.adsItem.id).then(res => {
        this.getAds();
      });
    }
  },
  mounted() {
    this.getAds();
  }
};
</script>

<style lang="scss" scoped>
.ads-list-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .left-part {
    flex: 1;
    display: flex;
    align-items: center;
    > span {
      margin-right: 10px;
      font-size: 16px;
    }
    .global-button-style {
      margin: 0;
    }
  }
  .list-container {
    flex: 1;
    display: flex;
    overflow: hidden;
    .aa {
      flex: 1;
      padding-right: 5px !important;
      flex-direction: column;
      .ads-item {
        display: flex;
        padding: 10px;
        background: #f7f7f7;
        margin-bottom: 10px;
        overflow: hidden;
        .ads-cover {
          width: 300px;
          .ads-img {
            height: 100%;
            width: 100%;
          }
        }
        .ads-info {
          flex: 1;
          margin: 0 20px;
          > p {
            margin: 5px 0;
          }
          .grey {
            color: #fff;
            background-color: #828282;
            padding: 4px 8px;
            font-size: 14px;
            border-radius: 2px;
          }
          .green {
            color: #fff;
            background-color: #3a983a;
            padding: 4px 8px;
            font-size: 14px;
            border-radius: 2px;
          }
        }
        .ads-btn {
          width: 200px;
          text-align: right;
          > .ads-el-icon {
            cursor: pointer;
            margin-left: 15px;
            font-size: 20px;
            padding: 2px;
            &:hover {
              background-color: #b5b5b5;
            }
            &.on-publish {
              color: #41b883;
            }
            &.off-publish {
              color: #d83a00;
            }
            &.disable-publish {
              color: #565656;
              cursor: not-allowed;
              &:hover {
                background-color: #dadada;
              }
            }
            &.ads-del {
              color: #d83a00;
            }
          }
        }
      }
    }
  }
}
</style>
